import nProgress from 'nprogress';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import '../../styles/nprogress.css';
import useAppTheme from './useAppTheme';

const COLOR_STYLE_ID = 'nprogress-color';

nProgress.configure({ showSpinner: false });

/**
 * Sets the bar colour through ONE shared <style> element. Appending a new
 * element per navigation leaked a <style> into document.body every time.
 *
 * @param {string} color
 */
export const setNProgressColor = (color) => {
  let style = document.getElementById(COLOR_STYLE_ID);
  if (!style) {
    style = document.createElement('style');
    style.id = COLOR_STYLE_ID;
    document.body.appendChild(style);
  }
  style.textContent = `
  #nprogress .bar {
    background: ${color} !important;
  }
  `;
};

/**
 * nProgress.done() throws "Cannot read properties of null (reading 'style')"
 * when #nprogress is gone or has no bar (removed by a faster follow-up
 * navigation, VANSITE-FRONTEND-4SD / -4SE).
 *
 * @returns {boolean}
 */
export const hasRenderedBar = () =>
  document.querySelector(`#nprogress ${nProgress.settings.barSelector}`) !== null;

export function useNProgress() {
  const location = useLocation();
  const theme = useAppTheme();

  useEffect(() => {
    setNProgressColor(theme.palette.primary.main);
    nProgress.start();
    // Simulate "routeChangeComplete" after navigation
    const timeout = setTimeout(() => {
      if (hasRenderedBar()) {
        nProgress.done();
        return;
      }
      // Without a bar, skipping done() would leave nProgress "started" and the
      // next start() would never render again — reset instead.
      nProgress.remove();
      nProgress.status = null;
    }, 100);
    return () => clearTimeout(timeout);
  }, [location]);
}
